<template>
  <div class="main_body">
    <img class="top" :src="hrefs + 'icon_351.png'" />
    <ul class="ul">
      <div v-for="(item, index) in xrList" data-index="index" :key="index"  @click="onReceive(item.id)">
        <li class="li" v-if="item.pic">
          <img v-if="item.statusGet == 1" class="img_01" :src="hrefs + 'icon_332.png'" />
          <img v-if="item.statusGet == 0" class="img_01" :src="hrefs + 'icon_342.png'" />
          <img class="img_00" :src="item.pic" />
        </li>
      </div>
    </ul>
    <img class="bot" :src="hrefs + 'icon_361.png'" />
  </div>
</template>
<script>
import { Toast } from 'vant'
import { couponlistGet, couponAdd } from '@/request/api.js'
export default {
  components: {
    [Toast.name]: Toast
  },
  data() {
    return {
      hrefs: 'https://www.soujingpin.com/style/images/',
      xrList: []
    }
  },
  methods: {
    onReceive(id) {
      const params = {
        couponId: id
      }
      couponAdd(id, params).then(res => {
        console.log(res)
        if (res.code === 200) {
          Toast({
            duration: 1000, // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: 'success',
            message: res.message
          })
          this.instrsnai()
        } else {
          Toast({
            duration: 1000, // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: 'fail',
            message: res.message
          })
        }
      })
    },
    instrsnai() {
      const params = {
        typeGet: 0
      }
      couponlistGet(params).then(res => {
        if (res.code === 200) {
          console.log(res)
          this.xrList = res.data
        }
      })
    }
  },
  created() {
    this.instrsnai()
  }
}
</script>
<style lang="less" scoped>
.main_body {
    background: #f1d4a8;
}
.top {
    width: 100%;
    height: 350px;
}
.ul {
  width: 710px;
  margin: 40px auto;
  overflow: hidden;
}
.ul .li {
  float: left;
  width: 710px;
  height: 230px;
  margin-bottom: 20px;
  position: relative;
}
.ul .li img {
  float: left;
  width: 710px;
  height: 230px;
}
.ul img.img_00 {
  position: relative;
}
.ul img.img_01 {
  width: 710px;
  height: 230px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}
.bot{
    width: 100%;
    height: 470px;
}
</style>
